import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Component
import SearchForm from "../../component/search-form";
import { sanitizeInput } from "../../utils";
import useDebounce from "../../Hook/useDebounce";
import SKUTable from "./Component/SKUTable";

function SKUIndex() {
  const navigate = useNavigate();
  // States
  const [searchText, setSearchText] = useState();

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 300);

  return (
    <>
      <div className="mt-4 sm:mx-6 lg:mx-8 space-y-6">
        <div className="space-y-2">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
            <div className="space-x-4 flex items-center">
              <h4 className="text-xl leading-5 font-bold tracking-tight">
                SKU List
              </h4>
              <SearchForm
                placeholder="Search"
                onChange={(e) => {
                  const value = sanitizeInput(e.target.value);
                  setSearchText(value);
                }}
                value={searchText}
              />
            </div>

            <div className="space-x-4 flex items-center justify-end">
              <button
                className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                onClick={(e) => navigate("/sku/create")}
              >
                <span className={`fas fa-plus mr-2`}></span>
                Create New SKU
              </button>
            </div>
          </div>
          <SKUTable debouncedHandleSearch={debouncedHandleSearch} />
        </div>
      </div>
    </>
  );
}

SKUIndex.auth = {
  path: "/sku/overview",
  role: "super-admin admin",
};

export default SKUIndex;
